module.exports = __webpack_public_path__ + "static/media/ro.3ae921a5.svg";